import styled from 'styled-components';
import { HiTrash } from 'react-icons/hi';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    width: 400px;
    color: var(--secondary-font-color);
    position: absolute;
    top: 70px;
    left: -50px;
    box-shadow: 0px 0px 2px 0px var(--secondary-font-color);
    transition: height 0.5s;
    max-width: 95vw;
    height: ${(props) => (props.Show ? '600px' : '0')};

    @media (max-width: 1400px) {
        top: 90px;
    }

    @media screen and (max-width: 950px) {
        left: -10px;
    }

    &:before {
        content: '';
        position: absolute;
        transform: ${(props) => (props.Show ? 'translateY(0)' : 'translateY(-100vh)')};
        transition: transform 0;
        transition-delay: ${(props) => (props.Show ? '0' : '0.5s')};
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 15px 15px 15px;
        border-color: transparent transparent var(--second-auxiliary-color) transparent;
        top: -15px;
        left: 50px;

        @media screen and (max-width: 950px) {
            left: 10px;
        }
    }
`;

export const Content = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${(props) => (props.Empty ? 'center' : 'flex-start')};
    width: 100%;
    overflow: auto;
    position: relative;
    z-index: 1;
    height: 100%;
    background-color: var(--second-auxiliary-color);
    border-radius: 3px;
    @media (max-width: 1050px) {
        width: 90%;
        margin-right: 550px;
    }

    &::-webkit-scrollbar {
        background-color: var(--table-secondary-color);
        width: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #ee6c4d7f;
    }
`;

export const BackgroundClose = styled.div`
    display: ${(props) => !props.Show && 'none'};
    z-index: -1;
    width: 100%;
    height: calc(100vh - 60px);
    background-color: transparent;
    position: fixed;
    top: 60px;
    left: 0;
`;

export const NotificationContainer = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
    padding: 2px 10px;
    border-bottom: 2px solid var(--table-border-color);
    font-weight: ${({ seen }) => (!!seen ? 'normal' : 'bold')};
    color: ${({ seen }) => !!seen || 'var(--main-color)'};

    &:hover {
        background-color: var(--first-auxiliary-color);

        span {
            background-color: var(--first-auxiliary-color);
        }
    }
    // h3, span {
    //   color: var(--first-auxiliary-color) !important;
    // }
`;

export const Title = styled.h1`
    display: ${(props) => !props.Empty && 'none'};
`;

export const RemoveIcon = styled(HiTrash)`
    cursor: pointer;

    &:hover {
        transform: scale(1.2);
        color: var(--main-color);
    }
`;
export const AlertWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 10px;
    padding: 8px 0;
`;

export const AlertDateTime = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2px;
    margin-right: 8px;
    min-width: 100px;

    h4 {
        margin: 0;
        font-size: 0.9rem;
    }
`;

export const AlertContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    h3 {
        margin: 0;
        font-size: 1rem;
    }

    span {
        font-size: 0.9rem;
        margin-top: 2px;
    }
`;

export const RemoveAlertIcon = styled.div`
    cursor: pointer;
    margin-left: auto;

    svg {
        width: 25px;
        height: 25px;
        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.1);
            color: var(--main-color);
        }
    }

    @media (max-width: 768px) {
        align-self: flex-start;
        margin-left: 0;
    }
`;
